
import ViewUserForm from '@/components/Management/User/ViewUserForm';

export default {
  components: {
    ViewUserForm
  }
};
